import { datastore } from '@shared/api'

export interface BigBoxOption {
	label: string
	value: string
}

async function loadOptions(): Promise<BigBoxOption[]> {
	if (typeof window === 'undefined' || !window.location.pathname.includes('/_blox_preview')) return []

	try {
		const [seriesResponse, symposiaResponse] = await Promise.all([
			datastore.collections.get({
				store: 'the_torah',
				collectionName: 'series',
				limit: 1000,
			}),
			datastore.collections.get({
				store: 'the_torah',
				collectionName: 'symposia',
				limit: 1000,
			}),
		])
		const seriesItems = Array.isArray(seriesResponse) ? seriesResponse : []
		const symposiumItems = Array.isArray(symposiaResponse) ? symposiaResponse : []

		return [
			...seriesItems.map((item: any) => ({
				label: `Series · ${item.title || item.name || item.slug || 'Untitled'}`,
				value: `series:${item._id || item.id || item.slug}`,
			})),
			...symposiumItems.map((item: any) => ({
				label: `Symposium · ${item.title || item.name || item.slug || 'Untitled'}`,
				value: `symposia:${item._id || item.id || item.slug}`,
			})),
		]
	} catch (error) {
		console.error('[BlockBigBox] Failed to load editor options:', error)
		return []
	}
}

export const bigBoxOptions = await loadOptions()
